'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _css2 = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css3 = require('antd/lib/select/style/css');

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = _select2.default.Option; /**
                                       * 添加商品规格
                                       */


var ProductSpec = _react2.default.createClass({
    displayName: 'ProductSpec',
    onSelectSpecName: function onSelectSpecName(index, event) {
        event.preventDefault();
        this.props.onSelectSpecName(index, event.target.value);
    },
    render: function render() {
        var _this = this;

        var _props = this.props,
            addedSpecs = _props.addedSpecs,
            onAddSpecItem = _props.onAddSpecItem,
            onDelSpecItem = _props.onDelSpecItem,
            onChangeSpecValue = _props.onChangeSpecValue,
            onSelectSpecName = _props.onSelectSpecName;

        return _react2.default.createElement(
            'div',
            null,
            addedSpecs.map(function (spec, index) {
                return _react2.default.createElement(
                    'div',
                    { key: index },
                    _react2.default.createElement(_input2.default, { style: { display: 'inline-block', width: 'auto', minWidth: '5em', marginRight: '2em' }, onChange: _this.onSelectSpecName.bind(null, index), placeholder: '\u8BF7\u8F93\u5165\u89C4\u683C\u9879\u76EE', defaultValue: spec.name }),
                    _react2.default.createElement(_select2.default, { tags: true,
                        style: { display: 'inline-block', width: 'auto', minWidth: 200, marginRight: 10 },
                        placeholder: '\u8BF7\u8F93\u5165\u89C4\u683C\u503C\uFF0C\u6309\u56DE\u8F66\u952E\u786E\u5B9A',
                        onChange: onChangeSpecValue.bind(null, index),
                        dropdownStyle: { display: 'none' },
                        defaultValue: spec.values
                    }),
                    _react2.default.createElement(
                        _button2.default,
                        { type: 'primary', onClick: onDelSpecItem.bind(null, index) },
                        '\u5220\u9664\u89C4\u683C'
                    )
                );
            }),
            _react2.default.createElement(
                _button2.default,
                { onClick: onAddSpecItem, style: addedSpecs.length === 3 ? { display: 'none' } : { display: 'inline-block' } },
                '\u6DFB\u52A0\u89C4\u683C'
            )
        );
    }
});

exports.default = ProductSpec;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/product_spec.js
// module id = 1491
// module chunks = 0